<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      :selection="true"
      :auto-refresh="true"
      labelWidth="120px"
    ></STable>
  </div>
</template>

<script>
import fieldFilter from "@/utils/fieldFilter.js";
import { HOST, EV_HOST } from "@/utils/host";
export default {
  name: "batteryAlarm",
  components: {},
  data() {
    return {
      url: "/battery/alarm/page",
      brandData: [],
      columns: [
        {
          label: "设备名称",
          prop: "deviceName"
        },
        {
          label: "品牌型号",
          prop: "brandModel"
        },
        {
          label: "项目名称",
          prop: "projectName"
        },
        {
          label: "企业名称",
          prop: "companyName"
        },
        {
          label: "告警等级",
          prop: "alarmLevel"
        },
        {
          label: "告警时间",
          prop: "alarmTime"
        },
        {
          label: "短信",
          prop: "sendSms"
        },
        {
          label: "告警原因",
          prop: "reason"
        }
      ],
      // 操作栏
      handles: {
        width: 100,
        btns: [
          {
            label: "详情",
            style: "color:#00CC00",
            permission: "Batteryalarm.pagedetail",
            handle: resp => {
              this.$router.push({
                path: "./batteryAlarmDetail",
                query: { data: resp }
              });
            }
          }
          // {
          //   label:"删除",
          //   style:"color:red",
          //   url:"",
          //   method:"delete",
          //   permission:"",
          //   isConfirm: true,
          //   before:(index,record) => {
          //   return {
          //       id:record.id
          //   };
          //   },
          //   handle: () =>{
          //       this.$refs.tableref.queryTable();
          //   }
          // }
        ]
      },
      query: [
        {
          label: "设备名称",
          prop: "deviceName",
          placeholder: "请输入设备名称"
        },
        {
          label: "品牌型号",
          prop: "brandName",
          type: "cascadersingle",
          data: this.brandData,
          props: { value: "id", label: "name" },
          placeholder: "请选择品牌型号"
        },
        {
          label: "项目名称",
          prop: "projectName",
          placeholder: "请输入项目名称"
        },
        {
          label: "企业名称",
          prop: "companyName",
          placeholder: "请输入企业名称"
        },
        {
          label: "告警等级",
          prop: "alarmLevel",
          type: "select",
          placeholder: "请选择告警等级",
          data: [
            {
              label: "一级",
              value: 1
            },
            {
              label: "二级",
              value: 2
            },
            {
              label: "三级",
              value: 3
            }
          ]
        },
        // {
        //   label: "告警原因",
        //   prop: "belongOrg",
        //   type: "select",
        //   placeholder: "请选择告警原因",
        //   data: [
        //     {
        //       label: "温度过高",
        //       value: 1,
        //     },
        //     {
        //       label: "温度过高",
        //       value: 2,
        //     }
        //   ],
        // },
        {
          label: "短信通知",
          prop: "sendSms",
          type: "select",
          placeholder: "请选择短信通知",
          data: [
            {
              label: "否",
              value: 0
            },
            {
              label: "是",
              value: 1
            }
          ]
        },
        // {
        //   label: "告警开始时间",
        //   prop: "alarmStartTime",
        //   placeholder: "请选择告警开始时间",
        //   type: "date",
        //   option: {
        //     type: "datetime"
        //   }
        // },
        // {
        //   label: "告警结束时间",
        //   prop: "alarmEndTime",
        //   placeholder: "请选择告警结束时间",
        //   type: "date",
        //   option: {
        //     type: "datetime"
        //   }
        // }
        {
          label: "告警时间",
          prop: "alarmTime",
          placeholder: "",
          type: "date2",
          option: {
            type: "datetimerange",
            format: "yyyy-MM-dd HH:mm:ss"
          }
        }
      ],
      toolbar: [
        {
          label: "导出",
          permission: "Batteryalarm.report",
          type: "success",
          handle: resp => {
            const url = HOST + "/battery/alarm/export";
            let queryData = this.$refs.tableref.getQueryData();
            queryData.token = window.localStorage.getItem("token");
            queryData.companyId = window.localStorage.getItem("curCompanyId");
            if (queryData.alarmTime) {
              queryData.alarmTime = queryData.alarmTime.join(",");
            }
            if (queryData.brandName) {
              queryData.brandName = queryData.brandName.join(",");
            }
            console.log(queryData, "dddd");
            $.fileDownload(url, {
              httpMethod: "get",
              data: queryData,
              failCallback: (html, url) => {
                this.$notify({
                  title: "失败",
                  message: "导出失败",
                  type: "error"
                });
              }
            });
            if (queryData.alarmTime) {
              this.$refs.tableref.getQueryData().alarmTime = queryData.alarmTime.split(
                ","
              );
            }
            if (queryData.brandName) {
              this.$refs.tableref.getQueryData().brandName = queryData.brandName.split(
                ","
              );
            }
          }
        },
        {
          label: "删除",
          permission: "",
          type: "danger",
          isSelectRowShow: false,
          url: "/battery/alarm/delete",
          method: "delete",
          isConfirm: true,
          before: records => {
            let arr = [];
            records.map(ele => {
              arr.push(ele.id);
            });
            return {
              ids: arr
            };
          },
          handle: () => {
            this.$refs.tableref.queryTable();
          }
        }
      ]
    };
  },
  computed: {},
  methods: {
    getAlarmReason() {
      //告警原因
    },
    getBrandDataInfo() {
      this.$store.dispatch("form/handle", {
        url: "/battery/tree/brandModel",
        data: {},
        method: "get",
        callback: resp => {
          this.brandData = resp;
          this.getTreeData();
        }
      });
    },
    getTreeData() {
      for (var i = 0; i < this.brandData.length; i++) {
        if (this.brandData[i].children.length == 0) {
          // children若为空数组，则将children删除
          delete this.brandData[i].children;
        } else {
          for (var k = 0; k < this.brandData[i].children.length; k++) {
            if (this.brandData[i].children[k].children.length == 0) {
              // children若为空数组，则将children删除
              delete this.brandData[i].children[k].children;
            } else {
              for (
                var h = 0;
                h < this.brandData[i].children[k].children.length;
                h++
              ) {
                if (
                  this.brandData[i].children[k].children[h].children.length == 0
                ) {
                  // children若为空数组，则将children删除
                  delete this.brandData[i].children[k].children[h].children;
                }
              }
            }
          }
        }
      }
      this.$refs.tableref.query[1].data = this.brandData;
    }
    // cascaderChange(param) {
    //   this.brandData.forEach(element=>{
    //     if(element.id==param.param[0]) {
    //       this.$refs.tableref.queryForm.brandName = element.name;
    //     }
    //     element.children.forEach(subElement=>{
    //       if(subElement.id==param.param[1]) {
    //         this.$refs.tableref.queryForm.modelName = subElement.name;
    //       }
    //     });
    //   });
    // }
  },
  created() {
    this.getBrandDataInfo();
  },
  mounted() {
    // setInterval(() => {
    //   this.$router.go(0); // 相当于刷新当前路由
    // }, 5000);
  },
  beforeCreate() {
    this.brandData = [];
  }, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/BMS/alarmManagement/batteryAlarm/batteryAlarm.vue